module.exports = __webpack_public_path__ + "static/media/birds-fly-cut.gif";